import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { ImageInterface, setEditId, setEditError, selectImageById } from "../../../store/community/imagesSlice";
import { updateImage, fetchImage } from "../../../actions/community/imagesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch  = useAppDispatch();
  const location  = useLocation();
  const id: any   = useAppSelector(state => state.community.images.editId);
  const error     = useAppSelector(state => state.community.images.editError);
  const image   = useAppSelector(state => id ? selectImageById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchImage(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: ImageInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: ImageInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateImage({ id, data: formData }));

    if (updateImage.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-image'>
        <h6 className="v-content-label">Edit Image</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={image} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
